import SidebarBookingsSummaryIndexController from 'uplisting-frontend/pods/-sidebar/bookings/summary/index/controller';

export default class SidebarBookingsSummaryAcceptController extends SidebarBookingsSummaryIndexController {}
